module.exports = __webpack_public_path__ + "assets/webgl/Assets_4_base_color.jpg.pvr.537bccff.ktx";